const state = {
    campaign_statuses:[
        {
            "value": "ACTIVO",
            "description": "La campaña aún no empieza.",
            "chipColor": "#dcd6ea",
            "textColor": "#2b2b2b"
        },
        {
            "value": "FINALIZADO",
            "description": "La campaña aún no empieza.",
            "chipColor": "#d5dee4",
            "textColor": "#2b2b2b"
        },
        {
            "value": "POR INICIAR",
            "description": "La campaña aún no empieza.",
            "chipColor": "#cdeee0",
            "textColor": "#2b2b2b"
        },
        {
            "value": "REVISANDO ESTATUS",
            "description": "La campaña aún no empieza.",
            "chipColor": "#eef4c8",
            "textColor": "#2b2b2b"
        }
    ],
};
const getters = {};

const actions = {};

const mutations = {};

export default{
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}